import api from './axios.js';

export const paymentsApi = {
  getPublicConfig: () => api.get('/payments/public-config'),
  getConfig: () => api.get('/payments/config'),
  completePaddleCheckout: (transactionId, payload = {}) => api.post(`/payments/paddle/transactions/${transactionId}/complete`, payload),
  createPortalSession: () => api.post('/payments/portal-session'),
};
